const PDFThumbnail = ({ sample, onClick }) => {
  const hasThumbnail = sample.thumbnail || sample.pdfUrl;

  return (
    <div 
      onClick={onClick}
      className={`relative aspect-[3/4] bg-white rounded-lg shadow-card overflow-hidden ${
        onClick ? 'cursor-pointer' : ''
      }`}
    >
      {hasThumbnail ? (
        <div className="w-full h-full">
          {sample.thumbnail && typeof sample.thumbnail === 'string' && sample.thumbnail.startsWith('data:image') ? (
            // Custom uploaded thumbnail
            <img 
              src={sample.thumbnail} 
              alt={sample.title}
              className="w-full h-full object-cover"
            />
          ) : sample.pdfUrl ? (
            // PDF preview (first page)
            <iframe
              src={`${sample.pdfUrl}#page=1&view=FitH&toolbar=0&navpanes=0`}
              className="w-full h-full pointer-events-none"
              title={sample.title}
            />
          ) : (
            // Placeholder
            <PlaceholderThumbnail edition={sample.edition} />
          )}
        </div>
      ) : (
        <PlaceholderThumbnail edition={sample.edition} />
      )}

      {/* Overlay gradient for better text visibility */}
      {hasThumbnail && (
        <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent pointer-events-none" />
      )}
    </div>
  );
};

// Placeholder Thumbnail Component
const PlaceholderThumbnail = ({ edition }) => {
  const bgColor = edition === 'micro' 
    ? 'bg-gradient-to-br from-accent-blue to-primary-green-light'
    : 'bg-gradient-to-br from-primary-green to-accent-yellow';

  const icon = edition === 'micro' ? '🌈' : '🚀';

  return (
    <div className={`w-full h-full ${bgColor} flex items-center justify-center`}>
      <div className="text-center text-white">
        <div className="text-8xl mb-4 opacity-80">{icon}</div>
        <div className="text-2xl font-display font-bold opacity-90">
          {edition === 'micro' ? 'Micro Edition' : 'Macro Edition'}
        </div>
        <div className="text-lg opacity-70 mt-2">
          Sample Preview
        </div>
      </div>
    </div>
  );
};

export default PDFThumbnail;